(function () {
  function shopifyImgWidth(src, width) {
    if (src.includes("width=")) {
      return src.replace(/width=\d+/, "width=" + width);
    }
    return src + (src.includes("?") ? "&" : "?") + "width=" + width;
  }

  document.addEventListener("click", function (event) {
    const link = event.target.closest(".product-card__variation-picker a");
    if (!link) return;

    const card = link.closest("product-card");
    if (!card) return;

    event.preventDefault();

    const wrapper = link.closest("[data-variation-handle]");
    if (!wrapper) return;

    const handle = wrapper.dataset.variationHandle;
    const url = wrapper.dataset.variationUrl;
    const title = wrapper.dataset.variationTitle;
    const imageSrc = wrapper.dataset.variationImage;
    const imageAlt = wrapper.dataset.variationImageAlt;
    const imageWidth =
      parseInt(wrapper.dataset.variationImageWidth, 10) || null;
    const imageHeight =
      parseInt(wrapper.dataset.variationImageHeight, 10) || null;
    const secondaryImageSrc = wrapper.dataset.variationSecondaryImage;
    const secondaryImageAlt = wrapper.dataset.variationSecondaryImageAlt;
    const secondaryImageWidth =
      parseInt(wrapper.dataset.variationSecondaryImageWidth, 10) || null;
    const secondaryImageHeight =
      parseInt(wrapper.dataset.variationSecondaryImageHeight, 10) || null;

    // Update selected state on swatches
    card
      .querySelectorAll(".product-card__variation-picker .color-swatch")
      .forEach(function (s) {
        s.classList.remove("is-selected");
      });
    link.classList.add("is-selected");

    // Update card handle attribute (used by existing variant-change logic in ProductCard)
    card.setAttribute("handle", handle);

    // Update figure link(s)
    card.querySelectorAll(".product-card__figure a").forEach(function (a) {
      a.href = url;
    });

    // Update title link
    const titleLink = card.querySelector(".product-card__title a");
    if (titleLink) {
      titleLink.textContent = title;
      titleLink.href = url;
    }

    // Swap primary image
    if (imageSrc) {
      const primaryImg = card.querySelector(".product-card__image--primary");
      if (primaryImg) {
        const widths = [
          200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800,
        ];
        primaryImg.srcset = widths
          .map(function (w) {
            return shopifyImgWidth(imageSrc, w) + " " + w + "w";
          })
          .join(", ");
        primaryImg.src = shopifyImgWidth(imageSrc, 800);
        primaryImg.alt = imageAlt || title;
        if (imageWidth) primaryImg.width = imageWidth;
        if (imageHeight) primaryImg.height = imageHeight;
      }
    }

    // Swap secondary (hover) image
    const secondaryImg = card.querySelector(".product-card__image--secondary");
    if (secondaryImg && secondaryImageSrc) {
      const widths = [
        200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800,
      ];
      secondaryImg.srcset = widths
        .map(function (w) {
          return shopifyImgWidth(secondaryImageSrc, w) + " " + w + "w";
        })
        .join(", ");
      secondaryImg.src = shopifyImgWidth(secondaryImageSrc, 800);
      secondaryImg.alt = secondaryImageAlt || title;
      if (secondaryImageWidth) secondaryImg.width = secondaryImageWidth;
      if (secondaryImageHeight) secondaryImg.height = secondaryImageHeight;
    }

    // Swap price via pre-rendered <template>
    let priceTemplate = null;
    card.querySelectorAll("template[data-price-for]").forEach(function (t) {
      if (t.dataset.priceFor === handle) priceTemplate = t;
    });
    const currentPriceList = card.querySelector("price-list");
    if (priceTemplate && currentPriceList) {
      currentPriceList.replaceWith(priceTemplate.content.cloneNode(true));
    }
  });
})();
